import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";
import { DaysAfterDateInput, DaysAfterDateText } from "./DaysAfterDateRow";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const ContractSection = (props: Props): FormSection => {
  return {
    key: "contractSettings",
    type: "regular",
    title: site.currentEnvironment.contract.singular,
    fields: [{
      key: "contract_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <YesNoText value={props.instruction.contractEnabled} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.contractEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.contractEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, contractEnabled: value });
        }
      }
    },
    {
      key: "contract_costs",
      label: RESX.Financial.Costs,
      render: () => <YesNoText value={props.instruction.contractDisplayCosts} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.contractDisplayCosts}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.contractDisplayCosts,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, contractDisplayCosts: value });
        }
      }
    },
    {
      key: "contract_dueDate",
      label: RESX.DateTime.DueDate,
      render: () => <DaysAfterDateText days={props.instruction.contractDefaultDuration} type="send" />,
      inPageEdit: {
        render: ({ onChange, value, cancel }) => <DaysAfterDateInput
          value={value}
          onChange={onChange}
          maxValue={serverReference.constants.document.maxDueDateInterval}
          type="send"
          onEnter={v => onChange(v, true)}
          onEsc={cancel}
        />,
        type: "confirmOrCancelButton",
        initialValue: props.instruction.contractDefaultDuration,
        submitChange: (value: number) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, contractDefaultDuration: value });
        }
      }
    }]
  }
}